// extracted by mini-css-extract-plugin
export var frequentlyAskedQuestion = "FrequentlyAskedQuestion-module__frequentlyAskedQuestion___LRcDa";
export var frequentlyAskedQuestionAnswer = "FrequentlyAskedQuestion-module__frequentlyAskedQuestionAnswer___C7MTy";
export var frequentlyAskedQuestionContainer = "FrequentlyAskedQuestion-module__frequentlyAskedQuestionContainer___6PV5I";
export var frequentlyAskedQuestionText = "FrequentlyAskedQuestion-module__frequentlyAskedQuestionText___jjScs";
export var icon = "FrequentlyAskedQuestion-module__icon___UcteY";
export var question = "FrequentlyAskedQuestion-module__question___12nMf";
export var questionButton = "FrequentlyAskedQuestion-module__questionButton___Vft4X";